import React, { useState, useEffect } from "react";
import {
  Box,
  styled,
  Switch,
  Stack,
  FormControl,
  InputLabel,
  Snackbar,
  CircularProgress,
} from "@mui/material";
import { prefrenceData } from "./FieldJson";
import "../profile.scss";
import ComboBox from "../../ComboBox";
import { useDispatch, useSelector } from "react-redux";
import {
  fetchNotificationSettings,
  overRideNotifications,
  updateNotificationSettings,
} from "../../../Actions/PreferenceAction";
import "../../../assets/styles/checkboxRadio.scss";
import "../../../assets/styles/glButton.scss";

const AntSwitch = styled(Switch)(({ theme }) => ({
  width: 44,
  height: 24,
  padding: 0,
  display: "flex",
  borderRadius: 16,
  "&:active": {
    "& .MuiSwitch-thumb": {
      width: 15,
    },
    "& .MuiSwitch-switchBase.Mui-checked": {
      transform: "translateX(9px)",
    },
  },
  "& .MuiSwitch-switchBase": {
    padding: 2,
    "&.Mui-checked": {
      transform: "translateX(20px)",
      color: "#fff",
      "& + .MuiSwitch-track": {
        opacity: 1,
        backgroundColor: "rgba(8, 109, 171, 1)",
        ...theme.applyStyles("dark", {
          backgroundColor: "rgba(8, 109, 171, 1)",
        }),
      },
    },
  },
  "& .MuiSwitch-thumb": {
    boxShadow: "0 2px 4px 0 rgb(0 35 11 / 20%)",
    width: 20,
    height: 20,
    borderRadius: 16,
    pointerEvents: "none",
    transition: theme.transitions.create(["width"], {
      duration: 200,
    }),
  },
  "& .MuiSwitch-track": {
    borderRadius: 16 / 2,
    opacity: 1,
    backgroundColor: "rgba(0,0,0,.25)",
    boxSizing: "border-box",
    ...theme.applyStyles("dark", {
      backgroundColor: "rgba(255,255,255,.35)",
    }),
  },
}));

const Preference = () => {
  const [formData, setFormData] = useState({});
  const [open, setOpen] = useState(false);
  const [message, setMessage] = useState("");
  const [classForToast, setClassForToast] = useState("");
  const [notifiBtnDisable, setNotifiBtnDisable] = useState(false);
  const [prefBtnDisable, setPrefBtnDisable] = useState(false);
  const lang = [
    {
      name: "English (US)",
      value: "en-us",
    },
  ];

  const {
    preferenceData,
    notificationChannel,
    updateStatus,
    error,
    successMessage,
    errorMessage,
  } = useSelector((state) => state.notificationData);
  const enableSnackbar = useSelector((state) => state.snackbar.enableSnackbar);
  const testModeEnabled = useSelector(
    (state) => state.snackbar.testModeEnabled
  );
  const dispatch = useDispatch();
  const handleToggle = (notificationId) => {
  setNotifiBtnDisable(true);

  const updatedNotificationChannel = notificationChannel.map((item) =>
    item.notificationId === notificationId
      ? { ...item, isActive: !item.isActive }
      : item
  );

  dispatch(overRideNotifications(notificationId));

  setFormData((prev) => ({
    ...prev,
    notificationChannel: updatedNotificationChannel,
  }));
};

  const handleInputChange = (value, name) => {
    setPrefBtnDisable(true);
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  useEffect(() => {
    if (preferenceData) {
      setFormData(preferenceData);
    }
  }, [preferenceData]);

  const handleSubmit = (e) => {
  e.preventDefault();
  let preferedLangValue = "";
  // const langObj = lang.find(
  //   (language) => formData.preferedLang === language.name
  // );
  const langObj = lang[0].name;
  if (langObj) {
    preferedLangValue = langObj;
  }

  dispatch(
    updateNotificationSettings(
      { ...formData, preferedLang: preferedLangValue },
      formData.notificationChannel || notificationChannel
    )
  );
};
  useEffect(() => {
    if (successMessage) {
      setToast(successMessage, "success");
    } else if (errorMessage) {
      setToast(errorMessage, "error");
    }
  }, [successMessage, errorMessage]);

  useEffect(() => {
    if (updateStatus) {
      setMessage(updateStatus);
      setOpen(true);
    } else if (error) {
      setMessage(error);
      // setOpen(true);
    }
  }, [updateStatus, error]);

  const setToast = (msg, type) => {
    setMessage(msg);
    setClassForToast(type);
    setOpen(true);
  };

  useEffect(() => {
    dispatch(fetchNotificationSettings());
  }, []);

  const handleClose = () => {
    setOpen(false);
    setMessage("");
    setClassForToast("");
  };

  const notificationDescriptions = {
    SMS: "Receive important notifications via text message",
    Email: "Receive personalized emails about account activites",
    "Push Notification": "Receive instant alerts directly to your device",
  };
const sortedNotificationChannel = [
  ...(formData.notificationChannel || notificationChannel),
].sort((a, b) => {
  const order = ["Email", "SMS", "Push Notification"];
  return order.indexOf(a.notificationName) - order.indexOf(b.notificationName);
});

  return (
    <div className="update_pass_mnWrapper">
      <div className="updatePassword_myacc">
        <div className="update_wrapper security_check_wrapper">
          <div
            className="profile-form"
            role="region"
            aria-labelledby="notification-heading"
          >
            <h2 id="notification-heading">Notifications</h2>

            {!sortedNotificationChannel ||
            sortedNotificationChannel.length === 0 ? (
              <Box
                role="status"
                aria-live="polite"
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  height: "100%",
                }}
              >
                <CircularProgress aria-label="Loading notification settings" />
              </Box>
            ) : (
              sortedNotificationChannel.map((data, index) => (
                <div className="securityChecks gl_toggle" key={data.id}>
                  <div className="sc_heading">
                    <p id={`label-Email`}>{data.notificationName}</p>
                    <span>
                      {notificationDescriptions[data.notificationName]}
                    </span>
                  </div>
                
                  <div
                    className="sc_toggle"
                    tabIndex={
                      data.notificationName === "Push Notification" ? -1 : 0
                    }
                    role="switch"
                    aria-checked={data.isActive}
                    aria-disabled={
                      data.notificationName === "Push Notification"
                        ? "true"
                        : "false"
                    }
                    aria-labelledby={`label-Email`}
                    onClick={(e) => {
                      e.stopPropagation();
                      handleToggle(data.notificationId);
                    }}
                    onKeyDown={(e) => {
                      if (e.key === "Enter" || e.key === " ") {
                        e.preventDefault();
                        handleToggle(data.notificationId);
                      }
                    }}
                  >
                    <Stack
                      direction="row"
                      spacing={1}
                      sx={{ alignItems: "center" }}
                    >
                      <AntSwitch
                        id={`switch-${data.notificationId}`}
                        disabled={data.notificationName === "Push Notification"}
                        checked={data.isActive}
                        // onChange={() => handleToggle(index)}
                        inputProps={{
                          "aria-hidden": true,
                          tabIndex: -1,
                        }}
                      />
                    </Stack>
                  </div>
                </div>
              ))
            )}

            <div className="profile_wrapperbtn">
              <button
                type="submit"
                className="btnSubmit save containedButton"
                data-testid="save-btn"
                aria-label="Save"
                disabled={!notifiBtnDisable}
                onClick={handleSubmit}
              >
                Save
              </button>
              <Snackbar
                open={open}
                className={classForToast === "error" ? "error" : "success"}
                anchorOrigin={{ vertical: "top", horizontal: "right" }}
                autoHideDuration={5000}
                message={message}
                onClose={handleClose}
                sx={{
                  pointerEvents: "none",
                  ...((enableSnackbar || testModeEnabled) && {
                    paddingTop: "45px",
                  }),
                }}
              />
            </div>
          </div>
        </div>
        <div className="update_wrapper">
          <div
            className="profile-form dropdownWrapper prefWrapper"
            role="region"
            aria-labelledby="preference-heading"
          >
            <h2 id="preference-heading">Preferences</h2>
            <Box
              component="form"
              noValidate
              autoComplete="off"
              className="field"
              role="form"
              aria-labelledby="preference-heading"
            >
              {prefrenceData.map((data, index) => (
                <FormControl
                  fullWidth
                  className="innerFields"
                  key={data.id || index}
                >
                  <InputLabel
                    variant="standard"
                    htmlFor={data.id}
                    shrink
                    aria-hidden="true"
                  >
                    {data.label}
                  </InputLabel>
                  <ComboBox
                    label={`Select a ${data.label}`}
                    ariaLabel={`Select a ${data.label}`}
                    value={formData[data.name] || ""}
                    onChange={(value) => handleInputChange(value, data.name)}
                    options={data.data?.map((role) => role.label)}
                  />
                </FormControl>
              ))}
            </Box>

            <div className="profile_wrapperbtn">
              <button
                type="submit"
                className="btnSubmit save containedButton"
                aria-label="Save"
                disabled={!prefBtnDisable}
                onClick={handleSubmit}
              >
                Save
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Preference;
